import { lazy } from 'react'
import { createBrowserRouter, Navigate } from 'react-router-dom'

import { privateLoader, publicLoader } from 'router/helper'
import allRoutes from 'shared/lib/allRoutes'

const AuthLayout = lazy(() => import('layout/auth-layout'))
const AdminLayout = lazy(() => import('layout/admin-layout'))

// const Login = lazy(() => import('app/auth/login'))
// const ForgotPassword = lazy(() => import('app/auth/forgot-password'))
// const ResetPassword = lazy(() => import('app/auth/reset-password'))
const Dashboard = lazy(() => import('app/private/dashboard'))

export const routes = (queryClient) =>
  createBrowserRouter([
    {
      element: <AuthLayout />,
      loader: publicLoader,
      children: [
        {
          path: allRoutes.dashboard,
          element: <Dashboard />
        },
        // {
        //   path: allRoutes.login,
        //   element: <Login />
        // },
        // {
        //   path: allRoutes.forgotPassword,
        //   element: <ForgotPassword />
        // },
        // {
        //   path: allRoutes.resetPassword,
        //   element: <ResetPassword />
        // },
        {
          path: '*',
          element: <Navigate to={allRoutes.dashboard} />
        }
      ]
    },
    {
      element: <AdminLayout />,
      loader: privateLoader(queryClient),
      children: [
        // {
        //   path: allRoutes.dashboard,
        //   element: <Dashboard />
        // },
        // {
        //   path: allRoutes.overview,
        //   handle: permissionData.VIEW_OVERVIEW,
        //   element: <Overview />
        // },
        // {
        //   path: allRoutes?.editManpower(':id'),
        //   handle: permissionData?.EDIT_MANPOWER,
        //   element: <AddEditManpower />
        // },
        // {
        //   path: allRoutes?.addCompany(':type'),
        //   handle: permissionData?.CREATE_MANAGE_COMPANY,
        //   element: <AddEditCompany />
        // },
        // {
        //   path: allRoutes?.editCompany(':type', ':id'),
        //   handle: permissionData?.EDIT_MANAGE_COMPANY,
        //   element: <AddEditCompany />
        // },
        {
          path: '*',
          element: <Navigate to={allRoutes.dashboard} />
        }
      ]
    }
  ])
